<template>
    <div>
            <CustomDialog ref='backdialog' :element='devDialog.element' :styles='devDialog.styles' >
                <template v-slot:dialog-content>
                    <back-task ref="backtask" @close='cancel' :showToast='showToast'></back-task>
                </template>
            </CustomDialog>
            <div class='h-toolbarBg'>
                <ejs-toolbar>
                    <e-items>
                        <e-item  prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Software.addRollbacktask")' :click='click' ></e-item>
                        <!-- <e-item  prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Software.delete")' :click='remove' ></e-item> -->
                        <e-item  prefixIcon='icon hero-icon hero-icon-auto-confirm' :tooltipText='$t("Software.redo")' :click='redo' ></e-item>
                    </e-items>
                </ejs-toolbar>
                <div class='h-inputBox'>
                    <ejs-textbox  :placeholder='$t("Software.enterKeywordSearchDevice")' @keydown.enter.native="search" v-model='input' />
                </div>
            </div>
            <div>
                <ejs-treegrid ref='grid' :dataSource='data' childMapping="subtasks"
                    :rowDataBound="rowDataBound" autoCheckHierarchy="true" collapsed="true" height='calc(100vh - 236px)' :allowResizing='true'>
                    <e-columns>
                        <e-column field='netCode' :headerText='$t("Software.td_neID")' width='12%' showCheckbox="true" clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='netType' :headerText='$t("Software.td_neName")' width='8%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='taskId' :headerText='$t("Software.td_taskId")' width='8%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='taskType' :headerText='$t("Software.td_taskType")' width='8%' :valueAccessor='taskTypeFormatter' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='operType' :headerText='$t("Software.td_operationType")' width='8%' :valueAccessor='operTypeFormatter' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='progress' :headerText='$t("Software.td_progress")' width='13%' :template='cTemplate' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='status' :headerText='$t("Software.td_status")' width='7%' :valueAccessor='statusFormatter' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='result' :headerText='$t("Software.td_result")' width='7%' :valueAccessor='resultFormatter' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='createTime' :headerText='$t("Software.td_createTime")' width='9%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='scheduledtime' :headerText='$t("Software.td_executionTime")' width='9%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='finishTime' :headerText='$t("Software.td_finishTime")' width='11%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='detail' :headerText='$t("Software.td_detail")' width='14%' clipMode='EllipsisWithTooltip'></e-column>
                        <e-column field='taskId' :isPrimaryKey='true' :visible='false' ></e-column>
                    </e-columns>
                </ejs-treegrid>
                <ejs-pager ref='pagerBack' @click='request' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
            </div>
    </div>
</template>

<script>
import Vue from "vue";
import { Page,Resize } from "@syncfusion/ej2-vue-treegrid";
import BasicLayout from '../../layouts/BasicLayout';
import CustomDialog from '../../components/common/CustomDialog';
import BackTask from '../../components/software/BackTask';
import Progress from '../../components/software/ProgressTemplate';
import socketInstance from '../../plugins/stompSock';
import { EventBus } from '../../plugins/eventBus';
let dataSource = [];
export default {
    components:{
        BasicLayout,
        CustomDialog,
        BackTask,
        Progress,
    },
    data() {
        return{
            left: { show: false, name: '' },
            middle: { show: false, name: '' },
            right: { show: true, crumb: this.$t('Software.softManage_back')},
            devDialog: {
                element: {
                    target: '#app',
                    isClose: true,
                    title: this.$t('Software.rb_version'),
                    refName: '',
                    buttonGroup: [
                        { click: this.cancel, buttonModel: { content: this.$t('MCS.cancle') } },
                        { click: this.submit, buttonModel: { content: this.$t('System.confirm'), isPrimary: true } },
                    ]
                },
                styles: {
                    width: '800px',
                    height: '710px',
                    visible: false,
                    model: true,
                    zIndex: 1001
                },
            },
            data: [],
            cTemplate: function(args) {
                return { template:Progress }
            },
            page: {
                pageNo: 1,
                pageSize: 15,
                totalCount: 0,
                pageCount: 4
            },
            input: '',
            taskmap: new Map().set(0,this.$t('Software.netask')).set(1,this.$t('Software.opetask')),
            opermap: new Map(
                [
                    [0,this.$t('Software.download')],
                    [1,this.$t('Software.active')],
                    [2,this.$t('Software.DlandAt')],
                    [3,this.$t('Software.rollback')],
                    [4,this.$t('Software.upload')],
                    [5,this.$t('Software.DlandUl')],
                    [6,this.$t('Software.AtandUl')],
                    [7,this.$t('Software.DlandAtandUl')],
                    [8,this.$t('Software.RbandUl')]
                ]),
            statusmap: new Map(
                [
                    [0,this.$t('Software.notstart')],
                    [1,this.$t('Software.waitforexe')],
                    [2,this.$t('Software.progressing')],
                    [3,this.$t('Software.done')],
                ]),
            resultmap: new Map(
                [
                    [0,this.$t('Software.success')],
                    [1,this.$t('Software.fail')],
                    [2,this.$t('Software.partSucc')],
                ]),
            payload: [
                {topic: '/topic/VmUpdateWsServer', clientId: '', callback: this.subscribeCallback}
            ]
        }
    },
    provide: {
      treegrid: [ Page,Resize],
    },
    mounted() {
        this.request();
        socketInstance.init(this.payload);
    },
    beforeDestroy() {
        for (let i = 0; i < this.payload.length; i++) {
            socketInstance.stopReceiveTopicMsg(this.payload[i].clientId, this.payload[i].topic);
        }
    },
    methods: {
        request() {
            let para={
                neName: '',
                taskstatus: '',
                taskresult: '',
                systemId:'1',
            }
            let page={
                    pageNo: this.$refs.pagerBack.ej2Instances.currentPage,
                    pageSize: this.$refs.pagerBack.ej2Instances.pageSize,
            };
            this.axios.post(`/lte/ems/verback_new/queryBackTask?pageNo=${page.pageNo}&pageSize=${page.pageSize}&neName=${this.input}`).then((response) => {
                if(response.data.errorCode == 'SUCCESS')
                {
                    dataSource = response.data.resultVal.result;
                    this.page.totalCount = response.data.resultVal.totalCount;
                    this.page.pageNo = response.data.resultVal.pageNo;
                    this.page.pageSize = response.data.resultVal.pageSize,
                    this.page.pageCount = response.data.resultVal.totalPages === 0 ? 1: response.data.resultVal.totalPages;
                    this.dataBinding(dataSource);
                }
            });
        },

        webSoketRequest()
        {
            const that =this;
            let para={
                neName: '',
                taskstatus: '',
                taskresult: '',
                systemId:'1',
            };
            let page={
                    pageNo: that.$refs.pagerBack.ej2Instances.currentPage,
                    pageSize: that.$refs.pagerBack.ej2Instances.pageSize,
            };
            that.axios.post(`/lte/ems/verback_new/queryBackTask?pageNo=${page.pageNo}&pageSize=${page.pageSize}&neName=${that.input}`).then((response) => {
                if(response.data.errorCode == 'SUCCESS'){
                    if(that.data.length !== response.data.resultVal.totalCount)
                    {
                        console.log('request');
                        that.request();
                        return;
                    }
                    dataSource = response.data.resultVal.result;
                    let newdata = JSON.parse(JSON.stringify(that.data));
                    newdata.forEach(item => {
                        dataSource.forEach(element =>{
                            if(item.taskId == element.taskId)
                            {
                                that.$refs.grid.setCellValue(item.taskId, 'status',element.status);
                                that.$refs.grid.setCellValue(item.taskId, 'progress',element.progress);
                                that.$refs.grid.setCellValue(item.taskId, 'result',element.result);
                                that.$refs.grid.setCellValue(item.taskId, 'scheduledtime',element.scheduledtime);
                                that.$refs.grid.setCellValue(item.taskId, 'detail',element.detail);
                            }
                            else if(item.taskId == element._parentId)
                            {
                                item.subtasks.forEach(model => {
                                    if(model.taskId == element.taskId)
                                    {
                                        that.$refs.grid.setCellValue(model.taskId, 'status',element.status);
                                        that.$refs.grid.setCellValue(model.taskId, 'progress',element.progress);
                                        that.$refs.grid.setCellValue(model.taskId, 'result',element.result);
                                        that.$refs.grid.setCellValue(model.taskId, 'scheduledtime',element.scheduledtime);
                                        that.$refs.grid.setCellValue(model.taskId, 'detail',element.detail);
                                    }
                                })
                            }
                        })
                    })
                }
            });
        },
        dataBinding(dataSource) {
            let resdata = [];
            dataSource.forEach(element => {
                if(element._parentId == null)
                {
                    let master = {};
                    master.taskId = element.taskId;
                    master.netCode = element.netCode;
                    master.netType = element.netType;
                    master.taskType = element.taskType;
                    master.operType = element.operType;
                    master.status = element.status;
                    master.progress = element.progress;
                    master.result = element.result;
                    master.createTime = element.createTime;
                    master.scheduledtime = element.scheduledtime;
                    master.detail = element.detail;
                    master.neId = element.neId;
                    master.subtasks = [];
                    resdata.push(master);
                }
                else{
                    let hasCont = false;
                    resdata.forEach(item => {
                        if(item.taskId == element._parentId)
                        {
                            hasCont = true;
                            item.subtasks.push(element);
                        }
                    })
                    //子数据存在而无父数据时列表展示（主要用于模糊搜索中的所有子任务的场景）
                    if(!hasCont)
                    {
                        resdata.push(element)
                    }
                }
            });
            this.data = resdata;
            console.log('this.data',this.data)
        },
        click(){
            this.$refs.backdialog.show();
            this.$refs.backtask._getNeTreeData();
        },
        taskTypeFormatter(field, data, column) {
            return this.taskmap.get(data['taskType']);
        },
        operTypeFormatter(field, data, column){
            return this.opermap.get(data['operType']);
        },
        statusFormatter(field, data, column){
            if(data['_parentId'] != undefined)
            {
                //根据子节点的状态还设置父节点的状态
                this.data.forEach(item => {
                    if(item.taskId === data['taskId'])
                    {
                        if(data['status'] > 2 && item.status < 2)
                        {
                            item.status = 2;
                        }
                    }
                })
            }
            return this.statusmap.get(data['status']);
        },
        resultFormatter(field, data, column){
            return this.resultmap.get(data['result']);
        },
        search(args) {
            // if(this.input !== '')
            // {
            //     const filterdata = dataSource.filter(item => this.filterMethod(item)).map(
            //         item => {return item}
            //     );
            //     this.dataBinding(filterdata);
            // }
            // else{
            //     this.dataBinding(dataSource);
            // }
            this.request();
        },
        //过滤方法
        filterMethod(item){
            const colmap = new Map([
                ['taskType', this.taskmap],
                ['operType', this.opermap],
                ['status', this.statusmap],
                ['result', this.resultmap],
            ])
            const colarray = ['netCode', 'netType','progress', 'createTime', 'scheduledtime', 'detail'];
            let feildData1 = Array.from(colarray, x => {
                return item[x] === null ? '' : item[x] +'';
            });
            let feildData2 = Array.from([...colmap.keys()], x =>{
                var mapvalue = colmap.get(x).get(item[x]);
                return mapvalue === undefined ? '' : mapvalue;
            });
            let filres = false;
            [...feildData1, ...feildData2].forEach(item => {
                if(item.indexOf(this.input) > -1)
                {
                    filres = true;
                }
            })
            return filres;
        },
        submit(clickEvent) {
            if (clickEvent.keyCode === 13) {
                return;
            }
            this.$refs.backtask.backVersion(() => {
                    this.cancel();
                    this.request();
            });
        },
        cancel() {
            this.$refs.backdialog.clear();
            this.$refs.backdialog.close();
        },
        subscribeCallback(myData) {
            console.log('callback',myData);
            this.input = '';
            this.webSoketRequest();
        },
        getSelect() {
            const select = [];
            this.$refs.grid.getCheckedRecords().forEach(item => {
                if(item.level == 0)
                {
                    select.push(item);
                }
            })
            return select;
        },
        remove() {
            const delIds = this.getSelect().map(x => x.taskId +'');
            if(delIds.length == 0)
            {
                this.showToast('warning',`${this.$t("System.selectDelObj")}`);
                return;
            }
            this.$layer.confirm({
                msg: this.$t('LteUser.delConfirm'),
                btn2: {
                    msg: this.$t('System.confirm'),
                    func: () => {
                        this.$axios.post('/lte/ems/verback_new/delBackVerAction', delIds).then((response) => {
                            if(response.status == 200)
                            {
                                if(response.data.errorCode == 'SUCCESS')
                                {
                                    this.showToast('success', `${this.$t('Common.tips.success')}`);
                                }
                                else
                                {
                                    this.showToast('error',response.data.errorString);
                                }
                            }
                            this.request();
                        });
                    }
                },
                btn1: {
                    msg: this.$t('MCS.cancle')
                }
            });
        },
        redo() {
            const taskIds = this.getSelect().map(x => x.taskId +'');
            if(taskIds.length == 0)
            {
                this.showToast('warning',`${this.$t("Software.selectOprObj")}`);
                return;
            }

            const select = this.getSelect().filter(x => x.status == '2');
            if(select.length != 0)
            {
                this.showToast('warning',`${this.$t("Software.messionExist")}`);
                return;
            }

            this.$axios.post('/lte/ems/verback_new/reStartAction', taskIds).then((response) => {
                if(response.status == 200)
                {
                    if(response.data.errorCode == 'SUCCESS')
                    {
                        this.showToast('success', `${this.$t('Common.tips.success')}`);
                        // this.$layer.success();
                    }
                    else
                    {
                        this.showToast('error',response.data.errorString);
                    }
                }
                else{
                    this.showToast('error', `${this.$t('Common.tips.failure')}`);
                }
                this.request();
            });
        },
        rowDataBound(args){
            // 只允许整包删除适配包，treegrid 子args.data['level'] = 1
            if(args.data['level'] === 1){
              args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('h-system-disablecheckbox')
            }
        },
        showToast(type, content)
        {
            //this.$parent.showToast(type,content);
             EventBus.$emit('toast', {type: type, content: content});
        }

    }
}
</script>>
